import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router";
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { DataContext } from '../../../data/DataContext';
import { AuthContext } from '../../../authentication/Auth';
import { useTranslation } from "react-i18next";
import DropdownCustom from '../../../components/DropdownCustom';

import { summaryConfig } from "../../../data/dashboardConfig"
import firebaseUtil from '../../../data/FirebaseUtil';

export default function SummaryContainer(props) {
  const history = useHistory();
  const { sitevalue, loading } = props;
  const context = useContext(AuthContext);
  // DLR flag
  const { t } = useTranslation();
  const [computedArray, setComputedArray] = useState([]);
  // to highlight the title when its selected
  const { selectedTitle, setTitle } = props;
  const [isLoading, setIsLoading] = useState(loading);
  const location = useLocation();
  const [tileFilterVal, setTileFilterVal] = useState({})
  const [RDValue, setRDValue] = useState('d');
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext)
  let [dropdownValue, setDropdownValue] = useState(0);
  

  useEffect(() => {
    if (RDValue != 'd') {
      if (props.sitevalue === RDValue.site) {
        onDataChange(RDValue.value)
      }
      setRDValue('d')
    }
  }, [RDValue])


  useEffect(() => {
    getSummaryData();
  }, [sitevalue])

  /* uses RTDB Websockets commented Rob Galvin Apr 26
  useEffect(() => {
    SummaryCountServices.getAll(sitevalue, companyID).on('value', (snapshot) => {
      setRDValue({ value: snapshot.val(), site: sitevalue })
    });
    return () => {
      SummaryCountServices.getAll().off("value", (snapshot) => { onDataChange(snapshot.val()) });
    }
  }, [sitevalue])

  */

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem("firebase:previous_websocket_failure");
    }

    if(sessionStorage.getItem('selectedTile')){
      let deviceSearchObject = JSON.parse(sessionStorage.getItem('selectedTile'));
      setTileFilterVal(deviceSearchObject);
      setDropdownValue(deviceSearchObject.value)
      setTitle(deviceSearchObject)
      history.push({
        pathname: location.pathname,
        state: {
          deviceSearchObject: deviceSearchObject,
          selectedSitevalue: sessionStorage.getItem("selectedSite") ? sessionStorage.getItem("selectedSite") : sitevalue
        }
      })
    }
    
  }, [])

  const getSummaryData = async () => {
    setIsLoading(true);
    firebaseUtil.getDeviceCountAxios({"siteName": sitevalue}).then(response => {
      setRDValue({ value: response.data, site: sitevalue })
      setIsLoading(false);
    }).catch(error => {
        setIsLoading(false)
    })
  };

  const tileDefaultValue =  {
    "dbKey": "totalTracked",
    "color": "#FFFFFF",
    "countColor": "#000000",
    "title": "All States",
    "filter": "totalTracked",
    "label": "Total",
    "value": "totalTracked"
  }

  function onDataChange(items) {
    setIsLoading(true)
    let summaryConfigArray = summaryConfig;

    let summayCofigObject = summaryConfigArray[0].mobile.summaryDashboard;

    summayCofigObject["totalTracked"] = tileDefaultValue;

    const finalArray = [];
    const summayCofigObjectKeys = Object.keys(summayCofigObject);

    // Iterating over each key (GH) in the summayCofigObjectKeys array
    summayCofigObjectKeys.forEach((GH) => {
      // not showing atrisk tiles when DLR feature is off
        if (GH === 'atRisk' && (!mlPredictionStatus || !dlrFeatureFlag)) {
          // Skip adding atRisk if either flag is false
          return;
        }
        // If items is null or undefined
        if (items === null || items === undefined) {
            // Check if the current configuration's filter is 'totalTracked'
            if (summayCofigObject[GH].filter === 'totalTracked') {
                // Add an object to the beginning of finalArray with a sumCount of 0
                finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0, label: `${summayCofigObject[GH].title}`, value: GH });
                return;
            }
            // Adding an object to finalArray with default sumCount of 0 when items is null or undefined
            finalArray.push({ ...summayCofigObject[GH], sumCount: 0, label: `${summayCofigObject[GH].title}`, value: GH });
        } else if (items[GH] != null) {
            // If the item corresponding to GH exists in items
            if (summayCofigObject[GH].filter === 'totalTracked') {
                // Convert the value to a string and add an object to the beginning of finalArray
                let sumCountIs = "" + items[GH];
                finalArray.unshift({ ...summayCofigObject[GH], sumCount: items[GH], label: `${summayCofigObject[GH].title}`, value: GH });
                return;
            }
            // Adding an object to finalArray with the actual sumCount from items
            finalArray.push({ ...summayCofigObject[GH], sumCount: items[GH], label: `${summayCofigObject[GH].title}`, value: GH });
        } else {
            // If the item corresponding to GH does not exist in items
            if (summayCofigObject[GH].filter === 'totalTracked') {
                // Add an object to the beginning of finalArray with a sumCount of 0
                let sumCountIs = "" + items[GH];
                finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0, label: `${summayCofigObject[GH].title}`, value: GH });
                return;
            }
            // Adding an object to finalArray with default sumCount of 0 when GH is not in items
        finalArray.push({ ...summayCofigObject[GH], sumCount: 0, label: `${summayCofigObject[GH].title}`, value: GH })
      }
    })
    sessionStorage.setItem('summaryCountData', JSON.stringify(finalArray))
    props.getSummaryCount(finalArray);
    if (!sessionStorage.getItem('selectedTile')){
      setTileFilterVal(finalArray[0]);
      history.push({
        pathname: location.pathname,
        state: {
          deviceSearchObject: finalArray[0],
          selectedSitevalue: sessionStorage.getItem("selectedSite") ? sessionStorage.getItem("selectedSite") : sitevalue
        }
      })
    }
    setComputedArray(finalArray);
    setIsLoading(false)
}

  const handleDropdownChange = (event, computedArray) => {
    const selectedValue = event?.target?.value;
    let tileObject = computedArray.filter(ele => {
        return ele.value === selectedValue;
    })[0];
    setDropdownValue(tileObject.value);
    setTileFilterVal(tileObject);

    if (tileObject.sumCount >= 0) {
      sessionStorage.setItem('selectedTile', JSON.stringify(tileObject));
      history.push({
        pathname: `/dashboard/deviceslist/mobile-devices`,
        state: {
          deviceSearchObject: tileObject,
          selectedSitevalue: sitevalue,
        },
      });
    }
  };

  return (
    <DropdownCustom
        selectOpts={computedArray}
        onChange={event => handleDropdownChange(event, computedArray)}
        isLoading={isLoading}
        isSearchable={false}
        selectVal={tileFilterVal || tileDefaultValue}
      />
  );
}

SummaryContainer.propTypes = {
  sitevalue: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  getSummaryCount: PropTypes.func.isRequired
}